// Should be kept in sync with sass/_colors.scss
export default class Colors {
  public static vtdBlack = '#000';
  public static vtdWhite = '#fff';
  public static vtdBlue1000 = '#00394d';
  public static vtdBlue950 = '#0470a5';
  public static vtdBlue800 = '#0079b4';
  public static vtdBlue600 = '#009ddb';
  public static vtdBlue100 = '#c2e4ef';
  public static vtdGray800 = '#636a73';
  public static vtdGray900 = '#3c4650';
  public static vtdGray1000 = '#333e48';
  public static vtdGray50 = '#f6f6f6';
  public static vtdGray400 = '#b1b5b9';
  public static vtdGray700 = '#767d84';
  public static vtPink06 = '#C95F7F';
}
